import ProcessingModel from "../models/ProcessingModel";
import ProcessingType from "../models/ProcessingType";

export const GET_PROCESSING_CONFIG = "GET_PROCESSING_CONFIG";
export interface GetProcessingConfigAction {
    type: typeof GET_PROCESSING_CONFIG
}

export const GET_PROCESSING_CONFIG_SUCCESS = "GET_PROCESSING_CONFIG_SUCCESS";
export interface GetProcessingConfigSuccessAction {
    type: typeof GET_PROCESSING_CONFIG_SUCCESS
    payload: {
        [key in ProcessingType]?: ProcessingModel
    }
}

export type ProcessingActionsType = GetProcessingConfigAction | GetProcessingConfigSuccessAction;


export const sharedProcessingActions = {
    getProcessingConfig: (): GetProcessingConfigAction => {
        return {
            type: GET_PROCESSING_CONFIG,
        }
    },

    getProcessingConfigSuccess: (config: {
        [key in ProcessingType]?: ProcessingModel
    }): GetProcessingConfigSuccessAction => {
        return {
            type: GET_PROCESSING_CONFIG_SUCCESS,
            payload: config,
        }
    },
}